import React from 'react';

const Crown = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.3329 4.75833V12.7417C18.3329 15.0417 16.4663 16.9083 14.1663 16.9083H5.83294C5.44961 16.9083 5.08294 16.8583 4.72461 16.7583C4.20794 16.6167 4.04128 15.9583 4.42461 15.575L13.2829 6.71666C13.4663 6.53333 13.7413 6.49166 13.9996 6.54166C14.2663 6.59166 14.5579 6.51666 14.7663 6.31666L16.9079 4.16666C17.6913 3.38333 18.3329 3.64166 18.3329 4.75833Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.2003 6.13332L3.47533 14.8583C3.07533 15.2583 2.40866 15.1583 2.14199 14.6583C1.83366 14.0917 1.66699 13.4333 1.66699 12.7417V4.75832C1.66699 3.64165 2.30866 3.38332 3.09199 4.16665L5.24199 6.32499C5.56699 6.64165 6.10033 6.64165 6.42533 6.32499L9.40866 3.33332C9.73366 3.00832 10.267 3.00832 10.592 3.33332L12.2087 4.94999C12.5253 5.27499 12.5253 5.80832 12.2003 6.13332Z",
      fill: "white"
    }
  )
);
Crown.displayName = "Icons.Crown";

export { Crown };
//# sourceMappingURL=Crown.js.map
